(function ($) {
    DJ.addBehavior('reportAbusePopup', 'body', {
        attach: function () {
            const body = this;
            const LIMIT_CHAPTERS = 500;

            $(window).on('dialog:aftercreate', function (event, dialog, $element) {
                const abuseReport = body.querySelector('.brio-report-abuse .form-wrapper .button');
                const abuseReportTextArea = body.querySelector('.brio-report-abuse textarea');
                if (abuseReport) {
                    abuseReport.disabled = true; 
                }
                if (abuseReportTextArea) {
                    abuseReportTextArea.classList.add('brio-report-abuse-textarea');
                    const limitContainer = document.createElement('p');
                    limitContainer.classList.add('brio-report-abuse-limit-container');
                    limitContainer.innerHTML = `${Drupal.t('Content limited to 500 characters, remaining:')} <span class="brio-report-abuse-limit-count">${LIMIT_CHAPTERS}</span>`;
                    abuseReportTextArea.insertAdjacentElement('afterEnd', limitContainer);
                }
            });
            

            body.addEventListener("input", (event) => {
                if (event.target.classList.contains('brio-report-abuse-textarea')) {
                    const textareaEl = event.target;
                    const button = textareaEl.closest('.brio-report-abuse').querySelector('.form-wrapper .button');
                    const limitCount = textareaEl.closest('.brio-report-abuse').querySelector('.brio-report-abuse-limit-count');
                    const textField = textareaEl.value;
                    const leftSymbols = LIMIT_CHAPTERS - textField.length;
                    limitCount.innerHTML = leftSymbols;
                    
                    if (textField.length < 40 || textField.length >= 500) {
                        button.disabled = true; 
                    } else {
                        button.disabled = false; 
                    }
                }
            });
        }
    });
})(jQuery);
   
  